import moment from 'moment';
import {
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from '../../../../const';
import {
  GET_EMPLOYEE_REWARDS,
  INIT_REWARDS_TABLE_DATA,
  SET_EMPLOYEE_REWARD_ITEM,
  SET_EMPLOYEE_REWARDS,
  SET_EMPLOYEE_REWARDS_SEARCH,
  SET_EMPLOYEE_REWARDS_STATUS,
  SET_REWARD_ACTIVE_MONTH,
} from '../actions';

const initialState = {
  employeeRewards: [],
  employeeSearch: '',
  status: STATUS_NOT_REQUESTED,
  lastGetEmployeeRewardParams: {},
  activeMonth: moment(),
};

export const rewardsTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMPLOYEE_REWARDS:
      return {
        ...state,
        status: STATUS_LOADING,
        lastGetEmployeeRewardParams: action.payload,
      };

    case SET_EMPLOYEE_REWARDS_STATUS:
      return { ...state, status: action.payload };

    case SET_EMPLOYEE_REWARDS_SEARCH:
      return { ...state, employeeSearch: action.payload };

    case SET_EMPLOYEE_REWARDS:
      return {
        ...state,
        status: STATUS_SUCCESS,
        employeeRewards: action.payload,
      };

    case SET_EMPLOYEE_REWARD_ITEM: {
      const payload = action.payload;
      const updatedEmployeeRewards =
        state.employeeRewards?.data?.employeeRewards?.map((item) => {
          if (item.employee.id === payload.employeeId) {
            const isEmployeeReward = item.rewards.some(
              (r) => r.companyRewardId === payload.companyRewardId
            );

            return {
              ...item,
              rewards: isEmployeeReward
                ? item.rewards.map((reward) =>
                    reward.companyRewardId === payload.companyRewardId
                      ? payload
                      : reward
                  )
                : [...item.rewards, payload],
            };
          }
          return item;
        }) || [];

      return {
        ...state,
        employeeRewards: {
          ...state.employeeRewards,
          data: {
            ...state.employeeRewards?.data,
            employeeRewards: updatedEmployeeRewards,
          },
        },
      };
    }

    case SET_REWARD_ACTIVE_MONTH:
      return { ...state, activeMonth: action.payload };

    case INIT_REWARDS_TABLE_DATA:
      return initialState;

    default:
      return state;
  }
};
